<template>
  <div id="app">
    <div class="wrapper">
      <nave v-if="$route.meta.nave" />
      <router-view></router-view>
      <foter v-if="$route.meta.foter" id="bot" />
    </div>
  </div>
</template>

<script>
import nave from './components/nave.vue'
import foter from './components/foter.vue'

export default {
  name: 'App',
  components: { nave, foter },
  data() {
    return {}
  },
  created() {
    if (sessionStorage.getItem('key')) {
      return false
    } else {
      sessionStorage.setItem('key', 1)
    }
    if (sessionStorage.getItem('Sliceno')) {
      return false
    } else {
      sessionStorage.setItem('Sliceno', 0)
    }
  },
  mounted() {
    console.log(localStorage.getItem('VoidChainLang'))
    if (localStorage.getItem('VoidChainLang')) {
      this.$i18n.locale = localStorage.getItem('VoidChainLang')
    } else {
      localStorage.setItem('VoidChainLang', 'en-US')
      this.$i18n.locale = localStorage.getItem('VoidChainLang')
    }
  },
}
</script>

<style lang="scss">
#app {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
html,
body {
  padding: 0;
  margin: 0;
  cursor: default;
  background: #fbfcfd;
  .wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .header {
    flex: 0;
  }
  .app {
    flex: 1;
  }
  #bot {
    flex: 0;
  }
}
/*包含以下五种的链接*/
a {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
  text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
  text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
  text-decoration: none;
}
</style>
